import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRedisComponent } from './simple-icons-redis.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRedisComponent ],
    exports:      [ SimpleIconsRedisComponent ],
    bootstrap:    []
})
export class SimpleIconsRedisModule {}
